module.exports = __webpack_public_path__ + "img/792072ba90edb8f0a114614fe653f0ce.9d4422d2.jpg";